import { render, staticRenderFns } from "./PqtMeasurementRow.vue?vue&type=template&id=215b4db2&scoped=true"
import script from "./PqtMeasurementRow.vue?vue&type=script&lang=ts"
export * from "./PqtMeasurementRow.vue?vue&type=script&lang=ts"
import style0 from "./PqtMeasurementRow.vue?vue&type=style&index=0&id=215b4db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b4db2",
  null
  
)

export default component.exports